/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CustomVehicle } from '../models/CustomVehicle';
import type { FilteredVehicles } from '../models/FilteredVehicles';
import type { Vehicle2 } from '../models/Vehicle2';
import type { VehicleResolution } from '../models/VehicleResolution';
import type { VehicleSet } from '../models/VehicleSet';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class VehiclesService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * @returns Vehicle2 Vehicle
   * @throws ApiError
   */
  public createCustomVehicle({
    requestBody,
  }: {
    /**
     * Custom Vehicle Details
     */
    requestBody: CustomVehicle,
  }): CancelablePromise<Vehicle2> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/motor/vehicles',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Malformed Error`,
        401: `Auth Error`,
        403: `Forbidden Error`,
        422: `Invalid Error`,
      },
    });
  }

  /**
   * @returns FilteredVehicles FilteredVehicles
   * @throws ApiError
   */
  public filterVehicles({
    manufacturer,
    model,
    fuelType,
    trimLevel,
    include,
    make,
    productId,
  }: {
    manufacturer?: string,
    model?: string,
    fuelType?: string,
    trimLevel?: string,
    include?: string,
    make?: string,
    productId?: string,
  }): CancelablePromise<FilteredVehicles> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/motor/vehicles/filter',
      query: {
        'manufacturer': manufacturer,
        'model': model,
        'fuelType': fuelType,
        'trimLevel': trimLevel,
        'include': include,
        'make': make,
        'productId': productId,
      },
      errors: {
        400: `Malformed Error`,
        401: `Auth Error`,
        403: `Forbidden Error`,
        422: `Invalid Error`,
      },
    });
  }

  /**
   * @returns Vehicle2 Vehicle
   * @throws ApiError
   */
  public getVehicle({
    id,
    include,
  }: {
    id: string,
    include?: string,
  }): CancelablePromise<Vehicle2> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/motor/vehicles/{id}',
      path: {
        'id': id,
      },
      query: {
        'include': include,
      },
      errors: {
        400: `Malformed Error`,
        401: `Auth Error`,
        403: `Forbidden Error`,
        422: `Invalid Error`,
      },
    });
  }

  /**
   * @returns VehicleSet VehicleSet
   * @throws ApiError
   */
  public createVehicleSet({
    requestBody,
  }: {
    /**
     * The VRN List and the new UUID
     */
    requestBody: {
      id: string;
      vrns: Array<string>;
      customerId?: string | null;
      productId?: string | null;
      productDefinition?: Record<string, any>;
    },
  }): CancelablePromise<VehicleSet> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/motor/vehicle-sets',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Malformed Error`,
        401: `Auth Error`,
        403: `Forbidden Error`,
        422: `Invalid Error`,
      },
    });
  }

  /**
   * @returns VehicleSet VehicleSet
   * @throws ApiError
   */
  public createResolvedVehicleSet({
    requestBody,
  }: {
    /**
     * The VRN List and the new UUID
     */
    requestBody: {
      id: string;
      resolutions: Array<VehicleResolution>;
      customerId?: string | null;
      productId?: string | null;
    },
  }): CancelablePromise<VehicleSet> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/motor/resolved-vehicle-sets',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Malformed Error`,
        401: `Auth Error`,
        403: `Forbidden Error`,
        422: `Invalid Error`,
      },
    });
  }

  /**
   * @returns VehicleSet VehicleSet
   * @throws ApiError
   */
  public getVehicleSet({
    id,
    include,
  }: {
    id: string,
    include?: string,
  }): CancelablePromise<VehicleSet> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/motor/vehicle-sets/{id}',
      path: {
        'id': id,
      },
      query: {
        'include': include,
      },
      errors: {
        400: `Malformed Error`,
        401: `Auth Error`,
        403: `Forbidden Error`,
        422: `Invalid Error`,
      },
    });
  }

  /**
   * @returns VehicleSet VehicleSet
   * @throws ApiError
   */
  public resolveVehicleSetEntries({
    id,
    requestBody,
  }: {
    id: string,
    /**
     * List of VRNs and Vehicle IDs
     */
    requestBody: {
      resolutions: any[];
      items?: {
        vrn: string;
        vehicleId: string;
      };
    },
  }): CancelablePromise<VehicleSet> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/motor/vehicle-sets/{id}/resolve',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Malformed Error`,
        401: `Auth Error`,
        403: `Forbidden Error`,
        422: `Invalid Error`,
      },
    });
  }

  /**
   * @returns VehicleSet VehicleSet
   * @throws ApiError
   */
  public cloneVehicleSet({
    id,
    requestBody,
  }: {
    id: string,
    /**
     * List of additions and subtractions
     */
    requestBody: {
      newVehicleSetId: string;
      additions: Array<string>;
      subtractions: Array<string>;
    },
  }): CancelablePromise<VehicleSet> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/motor/vehicle-sets/{id}/clone',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Malformed Error`,
        401: `Auth Error`,
        403: `Forbidden Error`,
        422: `Invalid Error`,
      },
    });
  }

}
